<template>
  <div id="app">
    <h2>在线翻译</h2>
    <inputTrans v-on:formSubmit="inputText"></inputTrans>   <!-- 父组件接收子组件传递的参数 -->
    <outputTrans v-text='outputText'></outputTrans>    <!-- 父组件将数据传递给子组件 -->
  </div>
</template>

<script>
import InputTrans from "./components/InputTrans"
import OutputTrans from "./components/OutputTrans"

export default {
  name: 'App',
  data:function () {
    return{
      outputText:""
    }
  },
  components: {
    InputTrans,OutputTrans
  },
  methods:{
    inputText:function (text,lang) {   //text接收子组件传递的参数
      this.$http.get("https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20180829T104729Z.c748220945b0810f.dea5219423e0e58124ab50d29ee9408cdff55633&lang="+lang+"&text="+text).then((res)=>{
        this.outputText=res.body.text[0]
      })     //使用的Yandex网站,需要拼接key,lang,text
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}
#app h2{
  color: rgb(200,200,200)
}
</style>



// WEBPACK FOOTER //
// src/App.vue